// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".smaller-text[data-v-13d6de8c]{font-size:12px}p[data-v-13d6de8c]{margin-bottom:0}", "",{"version":3,"sources":["webpack://./src/components/Common/Stat.vue"],"names":[],"mappings":"AACA,+BACE,cAAA,CAGF,mBACE,eAAA","sourcesContent":["\n.smaller-text {\n  font-size: 12px;\n}\n\np {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
